import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureBookingPageView, isPostHogReady, registerBookingSuperProperties } from '../analytics';
import { rememberBookingLanding } from '../analytics/signupAttribution';

/** $pageview PostHog à chaque navigation SPA (Live booking — connectés + pathname). */
const PostHogPageViews: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    rememberBookingLanding(location.pathname, location.search);
    if (!isPostHogReady()) return;
    registerBookingSuperProperties();
    captureBookingPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default PostHogPageViews;
